export default "__VITE_ASSET__CHoxb4dP__"